<div class="sub-nav w-206px o-hidden" id="sub-navigation" [attr.data-test-id]="'sub-nav-container'" [class.nav-expanded]="isNavExpanded">
  <div class="section centered-vert justify-cont-sb sp-py-8 sp-pr-4 sp-pl-16">
    <h1 class="title fs-20px fw-700 ink-100-v2" id="new-nav-sub-nav-title" data-test-id="new-nav-sub-nav-title">{{ activeScreen | localize }}</h1>
    <toggle-nav uiId="subnav-toggle" action="collapse"></toggle-nav>
  </div>
  <div class="billing-info-banner centered-vert flex-d-c" *ngIf="accountIsInternal$ | async">
    <h2 class="mt-8px fs-12px">{{ "internal_account" | localize }}</h2>
  </div>
  <div class="billing-info-banner centered-vert flex-d-c" *ngIf="showUpgrade$ | async" [attr.data-test-id]="'remaining-trial-days-sub-navigation'">
    <button class="full-w mt-10px mb-11px" *ngIf="isTrial" (click)="goToBilling()" ui-button role="link" uiSize="default" uiShape="round" uiType="primary">
      <i class="mr-6px" ui-icon uiType="upgrade" uiTheme="fill"></i>
      <span>{{ "time_left_to_upgrade" | localize : { timeLeft: timeLeft } }}</span>
    </button>
    <div class="borderline" *ngIf="isTrial"></div>
  </div>
  <div id="sub-nav-container" [ngSwitch]="activeScreen">
    <home-sub-navigation *ngSwitchCase="'home'"></home-sub-navigation>
    <sessions-sub-navigation *ngSwitchCase="'okrs'"></sessions-sub-navigation>
    <kpis-sub-navigation *ngSwitchCase="'kpis'"></kpis-sub-navigation>
    <tasks-sub-navigation *ngSwitchCase="'tasks'"></tasks-sub-navigation>
    <whiteboards-sub-navigation *ngSwitchCase="'whiteboards'"></whiteboards-sub-navigation>
    <settings-sub-navigation *ngSwitchCase="'settings'"></settings-sub-navigation>
    <reports-sub-navigation *ngSwitchCase="'reports'"></reports-sub-navigation>
    <people-sub-navigation *ngSwitchCase="'people'"></people-sub-navigation>
    <insightboards-sub-navigation *ngSwitchCase="'insightboards'"></insightboards-sub-navigation>
  </div>
  <div class="billing-info-upgrade-plan" *ngIf="showUpgrade$ | async">
    <button class="sp-mx-10 sp-mt-10 sp-mb-11" *ngIf="!isTrial" (click)="goToBilling()" ui-button role="link" uiSize="default" uiShape="round">
      {{ "upgrade_plan" | localize }}
    </button>
  </div>
</div>
